export enum RiskLevel {
  LOW = 1,
  MEDIUM = 2,
  HIGH = 3
}

export enum RptSubsidiaryDownloadColumnEnum {
  year = 'year',
  companyName = 'companyName'
}